import styled from 'styled-components';
import TextAreaAutoResize from 'react-textarea-autosize';

const FieldInputCustom = styled(TextAreaAutoResize)`
  border-radius: 12px !important;
  padding: 10px 12px !important;
  width: 100%;
  &:focus {
    border-color: #007bff;
    outline: none !important;
    box-shadow: none !important;
  }
`;

function FieldInput(props) {
  return (
    <div
      style={{
        minHeight: '40px',
        display: 'flex',
        alignItems: 'end',
        paddingRight: '10px',
      }}
      className="floatingTextArea"
    >
      <FieldInputCustom
        id={props.id}
        type="text"
        style={{ height: '45px' }}
        className="floatingInputTextArea"
        placeholder=" "
        {...props}
      />
      <label htmlFor={props.id}>{props.floatingLabel}</label>
    </div>
  );
}

export default FieldInput;
